<i18n src="./resources/locales.json"></i18n>
<template>
  <v-select
    :items="emailSignatures"
    :label="$t('selectSignature')"
    :menu-props="{ contentClass: 'custom-scrollbar', closeOnContentClick: true }"
    item-text="name"
    item-value="_id"
    :value="selectedEmailSignature._id"
    @change="onSignatureChange"
  >
    <template v-slot:prepend-item>
      <v-list-item ripple @click="onCreateSignatureClick">
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('createNewSignature') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider class="mt-2"></v-divider>
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'EcsEmailSignatureSelection',

  computed: {
    ...mapGetters(['emailSignatures', 'selectedEmailSignature'])
  },

  created() {
    if (this.emailSignatures.length > 0) {
      this.setSelectedEmailSignature(this.emailSignatures[0]._id);
    }
  },

  watch: {
    emailSignatures(newValue, oldValue) {
      if (oldValue.length === 0 && newValue.length !== 0) {
        this.setSelectedEmailSignature(newValue[0]._id);
      }
    }
  },

  methods: {
    ...mapActions(['setSelectedEmailSignature', 'createEmailSignature']),

    onSignatureChange(value) {
      this.setSelectedEmailSignature(value);
    },

    onCreateSignatureClick() {
      this.createEmailSignature();
    }
  }
};
</script>

<style></style>
